// extracted by mini-css-extract-plugin
module.exports = {"links":"footer-links-list_links__c9WGB","link":"footer-links-list_link__P7Mp7"};